import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./view/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'pv-kalkulator',
    loadComponent: () =>
      import('./view/pv-kalkulator/pv-kalkulator.page').then(
        (m) => m.PvKalkulatorPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./view/settings/settings.page').then((m) => m.SettingsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'projects',
    loadComponent: () =>
      import('./view/projects/projects.page').then((m) => m.ProjectsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'project-detail/:id',
    loadComponent: () =>
      import('./view/project-detail/project-detail.page').then(
        (m) => m.ProjectDetailPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'capture-project-data',
    loadComponent: () =>
      import('./view/capture-project-data/capture-project-data.page').then(
        (m) => m.CaptureProjectDataPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'file-upload',
    loadComponent: () => import('./view/file-upload/file-upload.page').then( m => m.FileUploadPage)
  },
  {
    path: 'image-viewer',
    loadComponent: () => import('./view/image-viewer/image-viewer.page').then( m => m.ImageViewerPage)
  },
  {
    path: 'information',
    loadComponent: () => import('./view/information/information.page').then( m => m.InformationPage)
  },
];
